module.exports = __webpack_public_path__ + "static/media/flytta.1163c38d.mp3";